import { render, staticRenderFns } from "./AddressBudget.vue?vue&type=template&id=18bbadac&scoped=true&"
import script from "./AddressBudget.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddressBudget.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddressBudget.vue?vue&type=style&index=0&id=18bbadac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bbadac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpandTransition,VIcon})
